export enum EditorTab {
    Palette = 'palette',
    Properties = 'properties',
}

export const CKEDITOR_DOM = {
    HOST_TAG: 'ckeditor',
    EDITOR_ELEMENT_TAG: 'ckeditor-editor-element',
    EDITOR_SELECTOR: '.ck-editor',
    MAIN_SELECTOR: '.ck-editor__main',
    EDITABLE_SELECTOR: '.ck-editor__editable',
} as const;

export const INJECTED_STYLES_ID = 'rte-template-injected-styles';
